import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2 } from "lucide-react";

/** Admin → Connectivity: the IBKR Client Portal link. */
export const IbkrCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/venues/ibkr/status").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;

  return (
    <Card className="p-5 shadow-premium" data-testid="ibkr-card">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Building2 className="h-4 w-4" />Interactive Brokers
        </div>
        <Badge style={s.live ? { background: "rgba(14,143,110,0.12)", color: "#33265A" }
                             : { background: "rgba(120,120,120,0.12)", color: "#555" }}
          data-testid="ibkr-status-badge">
          {s.live ? "Gateway connected" : "Simulated"}
        </Badge>
      </div>

      <div className="space-y-2">
        {[["Mode", s.mode], ["Account", s.account_id],
          ["FX via broker", s.fx_via_broker ? "Yes" : "No (internal book)"],
          ["Reconciliation", s.reconciliation], ["Contracts cached", s.conids_cached]]
          .map(([k, v]) => (
            <div key={k} className="flex items-center justify-between rounded-lg border px-3 py-2">
              <span className="text-sm text-muted-foreground">{k}</span>
              <span className="text-sm numeric">{String(v)}</span>
            </div>
          ))}
      </div>

      <p className="text-xs text-muted-foreground mt-3 leading-relaxed" data-testid="ibkr-note">{s.note}</p>
    </Card>
  );
};
